exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".checkbox-new {\n  width: 12px;\n  height: 12px;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  border-radius: 4px;\n  border: 1px solid #c6cae3;\n  cursor: pointer;\n  margin: 0;\n  margin-right: 6px;\n  position: relative;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.checkbox-new_read_only {\n  cursor: default;\n}\n.checkbox-new_margin-right-0 {\n  margin-right: 0;\n}\n.checkbox-new__img {\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  padding-bottom: 1px;\n}\n.checkbox-new_set {\n  background-color: #767b92;\n  border-color: #767b92;\n}\n.checkbox-new_set img {\n  opacity: 1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/postcss-loader!../node_modules/stylus-loader!./components/Checkbox/style.styl
// module id = ../node_modules/css-loader/index.js!../node_modules/postcss-loader/index.js!../node_modules/stylus-loader/index.js!./components/Checkbox/style.styl
// module chunks = 0